import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import { useContext } from 'react';
import { stripSlashFromEnd } from 'utils/ui';
import BackLinkProvider, { BackLinkContext } from './BackLinkProvider';
function useBackLink(options) {
  var fallback = options.fallback,
    basePath = options.basePath,
    shouldSkipLocation = options.shouldSkipLocation;
  var _useContext = useContext(BackLinkContext),
    historyStack = _useContext.historyStack,
    getLocationPathname = _useContext.getLocationPathname;
  if (historyStack.length <= 1) {
    return fallback;
  }
  function getShouldSkipLocation(location) {
    var formattedLocation = basePath ? stripSlashFromEnd(getLocationPathname(location)) : undefined;
    var ignoreSubpath = Array.isArray(basePath) ? basePath.some(function (path) {
      return formattedLocation === null || formattedLocation === void 0 ? void 0 : formattedLocation.startsWith(path);
    }) : basePath && (formattedLocation === null || formattedLocation === void 0 ? void 0 : formattedLocation.startsWith(basePath));
    var skipLocation = shouldSkipLocation === null || shouldSkipLocation === void 0 ? void 0 : shouldSkipLocation(location);
    return ignoreSubpath || skipLocation;
  }
  function getBackLink() {
    // Traverse the history stack in reverse
    // until a suitable backlink is found
    for (var i = historyStack.length - 2; i >= 0; i--) {
      var location = historyStack[i].location;
      if (!getShouldSkipLocation(location)) {
        return location;
      }
    }
  }
  var backLink = getBackLink();
  return backLink || fallback;
}
export { slicePathSegments } from 'utils/ui';
export { BackLinkProvider, BackLinkContext };
export default useBackLink;